import { useEffect } from "react";

import { string, func } from "prop-types";
import { connect } from "react-redux";
import { HeaderContainer } from "../UI/Containers";
import { getAllListingInfoAsThunk } from "./actions/thunks";
import {
  getAllDetailsAsThunk,
  getSourcesAsThunk,
  getPropertyTypesAsThunk,
} from "../Main/Details/actions/thunks";

import { tdpDetails } from "../../shared/HOCs/withRedux";
import { TRANSACTION_TYPE } from "../../shared/reduxRoutes/tdpDetailsRoutes";
import { isReferral } from "../shared/helpers";
import { fetchFinancials } from "../Main/Financials/actions/thunks";

import Summary from "./Summary";
import ReferralHeader from "./ReferralHeader";

const HeaderChildComponent = ({ type }) => (isReferral(type) ? <ReferralHeader /> : <Summary />);

const HeaderChildComponentWrapper = tdpDetails({
  WrappedComponent: HeaderChildComponent,
  states: TRANSACTION_TYPE,
});

const Header = ({
  onGetAllListingInfoAsThunk,
  onGetFinancials,
  onGetAllDetailsAsThunk,
  onGetSourcesAsThunk,
  onGetPropertyTypesAsThunk,
  uuid,
}) => {
  useEffect(() => {
    onGetAllListingInfoAsThunk(uuid).then(() => onGetFinancials());
    onGetAllDetailsAsThunk(uuid);
    onGetSourcesAsThunk(uuid);
    onGetPropertyTypesAsThunk(uuid);
  }, [uuid]);
  return (
    <div className="tw-flex tw-flow-column tw-justify-around tw-items-center">
      <HeaderContainer>
        <HeaderChildComponentWrapper />
      </HeaderContainer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  uuid: state.tdpDetailsReducer.uuid,
});

const mapDispatchToProps = (dispatch) => ({
  onGetAllListingInfoAsThunk: (uuid) => dispatch(getAllListingInfoAsThunk(uuid)),
  onGetFinancials: () => dispatch(fetchFinancials()),
  onGetAllDetailsAsThunk: (uuid) => dispatch(getAllDetailsAsThunk(uuid)),
  onGetSourcesAsThunk: (uuid) => dispatch(getSourcesAsThunk(uuid)),
  onGetPropertyTypesAsThunk: (uuid) => dispatch(getPropertyTypesAsThunk(uuid)),
});

Header.propTypes = {
  onGetAllListingInfoAsThunk: func.isRequired,
  uuid: string.isRequired,
  onGetFinancials: func,
  onGetAllDetailsAsThunk: func.isRequired,
  onGetSourcesAsThunk: func.isRequired,
  onGetPropertyTypesAsThunk: func.isRequired,
};

Header.defaultProps = {
  onGetFinancials: () => {},
};

HeaderChildComponent.propTypes = {
  type: string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
